"use client"

import { Phone } from "lucide-react"
import { FaFacebookF, FaInstagram, FaWhatsapp, FaTiktok } from "react-icons/fa"
import "./css/redes.css"

const Redes = () => {
  const socialLinks = [
    {
      name: "Facebook",
      url: "https://www.facebook.com/profile.php?id=61566663013218",
      icon: FaFacebookF,
      bgColor: "#1877f2",
      hoverColor: "#166fe5",
    },
    {
      name: "Instagram",
      url: "http://instagram.com/agrocorralgt",
      icon: FaInstagram,
      bgColor: "#e4405f",
      hoverColor: "#d62d4a",
    },
    {
      name: "TikTok",
      url: "https://www.tiktok.com/@agrocorral_gt",
      icon: FaTiktok,
      bgColor: "#000000e3",
      hoverColor: "#000",
    },
    {
      name: "WhatsApp",
      url: "https://wa.me/50230544755?text=Hola%20escribo%20de%20la%20p%C3%A1gina%20web%20quiero%20m%C3%A1s%20informaci%C3%B3n",
      icon: FaWhatsapp,
      bgColor: "#25d366",
      hoverColor: "#20ba5a",
    },
    {
      name: "Teléfono",
      url: "tel:+50230544755",
      icon: Phone,
      bgColor: "#6c757d",
      hoverColor: "#5a6268",
    },
    
  ]

  return (
    <div className="redes-sidebar">
      {socialLinks.map((social, index) => {
        const IconComponent = social.icon
        return (
          <a
            key={index}
            href={social.url}
            target={social.name === "Teléfono" ? "_self" : "_blank"}
            rel="noopener noreferrer"
            className="redes-link"
            style={{
              backgroundColor: social.bgColor,
              "--hover-color": social.hoverColor,
            }}
            aria-label={social.name}
            title={social.name}
          >
            <IconComponent size={20} />
          </a>
        )
      })}
    </div>
  )
}

export default Redes
